<div id="dropzone" #dropZone appDrag (files)="onFileChange($event)"></div>
